<script setup lang="ts">
import { useAppStore } from '@/store/modules/app';
import { useRouter } from "vue-router";
import { fetchGetUserMsg } from "@/service/api";
import CurApi from "@/service/api/manage-system/modules/site-mail/type";
const router = useRouter()

defineOptions({
  name: 'NoticeButton'
});

const handleNotices = () => {
  active.value = true;
  model.value = [];
  fetchGetUserMsgFn();
}

// 调用站内信接口
const letterTotal = ref<number>(0); // 总数
const model = ref<any>([]) // 列表数
const fetchGetUserMsgFn = async () => {
  try {
    const params = { type: 2 }
    const { data, error } = await fetchGetUserMsg(params);
    if (!error) {
      letterTotal.value = data?.unreadCount;
      if (data.records) {
        model.value = data.records.filter((item: CurApi.SiteMail) => {
          return item.readFlag === 0
        })
      } else {
        model.value = []
      }
    }
  } catch (error) {

  }
}

const appStore = useAppStore();
const active = ref<boolean>(false);

const arrowForward = () => {
  router.push({ name: 'personal', query: { pageType: 7 } });
  active.value = false;
}

onMounted(() => {
  fetchGetUserMsgFn()
})


</script>

<template>
  <n-badge :dot="letterTotal != 0" :offset="[-7, 10]">
    <ButtonIcon icon="material-symbols:notifications-sharp" tooltip-content="消息通知" @click="handleNotices" />
  </n-badge>

  <n-drawer v-model:show="active" :width="502">
    <n-drawer-content>
      <template #header>
        <div class="justify-between flex items-center">
          <div class="flex gap-4">
            <icon-mdi:email-newsletter class="texticon" />
            <div class="letter">站内信<span>(共{{ letterTotal }}条未读信息)</span></div>
          </div>
          <div>
            <icon-material-symbols:arrow-forward-ios class="texticons" @click="arrowForward" />
          </div>
        </div>
      </template>
      <template #default>
        <div class="flex-col gap-20px">
          <template v-if="model.length > 0">
            <div v-for="item in model" :key="item.id" class="letter-content">
              <div>{{ item.title }}</div>
              <div>
                {{ item.content }}
              </div>
            </div>
          </template>
          <n-empty v-else description="暂无消息"></n-empty>
        </div>
      </template>
      <template #footer>
        <n-button type="primary" ghost @click="active = false;">关闭</n-button>
      </template>
    </n-drawer-content>
  </n-drawer>

</template>

<style scoped lang="scss">
.texticons {
  font-size: 20px;
}

.texticons {
  font-size: 20px;
  cursor: pointer;

  &:hover {
    color: #5e62b2;
  }
}

.letter {
  span {
    font-size: 14px;
    font-weight: 500;
    margin-left: 5px;
  }
}

.letter-content {
  border-bottom: 1px solid #efeff5;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .detail {
    cursor: pointer;
    color: #0988d3;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
